document.addEventListener("DOMContentLoaded", () => {
  // H5P height resize.
  let iframes = document.querySelectorAll(
    ".md-stepper .h5p-iframe-wrapper iframe, .md-stepper .quiz-iframe-wrapper iframe, .md-stepper .scorm-iframe-wrapper iframe"
  );
  function processIframe(iframeItem) {
    let stepper = iframeItem.closest(".md-stepper");
    if (!stepper) {
      return;
    }
    let wrapper = iframeItem.closest(".md-steppers-wrapper");
    let setHeight = () => {
      //Set height of stepper only if visible and in active step.
      if (stepper.style.visibility !== "hidden") {
        let isActive = iframeItem.closest(".md-stepper-content").classList.contains("md-active");
        if (isActive) {
          wrapper.style.height = stepper.offsetHeight + "px";
          wrapper.scrollTop = 0;
        }
      }
    }
    setHeight();
    // Mutation observer
    if (iframeItem.observerAttached) {
      return;
    }
    const observer = new MutationObserver((mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "style"
        ) {
          setHeight();
        }
      }
    });
    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(iframeItem, config);
    iframeItem.observerAttached = true;
  }
  iframes.forEach(iframe => {
    if (iframe.contentWindow.document.readyState === "complete") {
      processIframe(iframe);
    }
    iframe.addEventListener("load", e => {
      let iframeItem = e.target;
      processIframe(iframeItem);
    });
    let iframeDoc = iframe.contentWindow;
    iframeDoc.addEventListener("resize", e => {
      processIframe(iframe);
    });
  });

  // window.addEventListener("load", () => {
  //   // Set default height.
  //   let activStep = document.querySelector(".md-stepper-content.md-active");
  //   if (activStep) {
  //     let stepper = activStep.closest(".md-stepper");
  //     let wrapper = activStep.closest(".md-steppers-wrapper");
  //     let iframe = activStep.querySelector("iframe.h5p-iframe");
  //     if (!iframe) {
  //       wrapper.style.height = stepper.offsetHeight + "px";
  //       wrapper.scrollTop = 0;
  //     }
  //   }
  // });
});
